import { useTranslation } from "react-i18next";
import switchIcon from "../assets/icons/icon-switch.svg";
import PromoImage1 from "../assets/images/promo-img-1.webp";
import PromoImage2 from "../assets/images/promo-img-2.webp";
import PromoImage3 from "../assets/images/promo-img-3.webp";
import PromoImage4 from "../assets/images/promo-img-4.webp";

const TRANSFER_OPTIONS_DATA = [
  { id: 1, label: "All Transfers", value: "all" },
  {
    id: 2,
    label: (
      <span className="flex gap-2">
        Partner <img src={switchIcon} alt="switch" /> Operator
      </span>
    ),
    value: "partner-operator",
  },
  {
    id: 3,
    label: (
      <span className="flex gap-2">
        Super Agent <img src={switchIcon} alt="switch" /> Partner
      </span>
    ),
    value: "super-agent-partner",
  },
  {
    id: 4,
    label: (
      <span className="flex gap-2">
        Agent <img src={switchIcon} alt="switch" /> Super Agent
      </span>
    ),
    value: "agent-super-agent",
  },
  {
    id: 5,
    label: (
      <span className="flex gap-2">
        Player <img src={switchIcon} alt="switch" /> Super Agent
      </span>
    ),
    value: "player-super-agent",
  },
  {
    id: 6,
    label: (
      <span className="flex gap-2">
        Player <img src={switchIcon} alt="switch" /> Agent
      </span>
    ),
    value: "player-agent",
  },
];
export const TRANSFER_OPTIONS = TRANSFER_OPTIONS_DATA.map((userOption) => ({
  value: userOption.value,
  label: userOption.label,
}));
export const trasnferData = [
  { user: "asbettest", role: "Super Agent", balance: "0.00", netBalanace: "0.00" },
  { user: "asbettest", role: "Super Agent", balance: "0.00", netBalanace: "0.00" },
  { user: "asbettest", role: "Super Agent", balance: "0.00", netBalanace: "0.00" },
  { user: "asbettest", role: "Super Agent", balance: "0.00", netBalanace: "0.00" },
];

export const PROMOTION_DATA = () => {
  const { t } = useTranslation();
  return [
    { image: PromoImage1, title: t("First Deposit Bonus"), shortDesc: t("Register now and get a 100% First Deposit Bonus") },
    {
      image: PromoImage2,
      title: t("Football Early Payout"),
      shortDesc: t("Pick the team that win by two goals at any time during the game and have your bet settled as won!"),
    },
    {
      image: PromoImage3,
      title: t("Basketball Early Payout"),
      shortDesc: t(
        "Place a single or a multiple bet on the Head to Head before the game starts and if your team is 20 points ahead at any point of the match win automatically!"
      ),
    },
    {
      image: PromoImage4,
      title: t("Tennis Early Payout"),
      shortDesc: t(
        "Place a single or a multiple bet on the tennis player you want to win, before the game starts and if your chosen player is 2 sets ahead at any point of the match win automatically!"
      ),
    },
  ];
};
